<div class="main-padding">
  <h3 class="mt-4 pt-3">All Organizations</h3>
  <app-result-count [count]="organizations.length">
    organizations
  </app-result-count>

  <div class="mt-3">
    <div class="mb-3" *ngFor="let item of organizations">
      <app-organization [organization]="item"
                        [wide]="true"
      ></app-organization>
    </div>
  </div>
</div>
